import { Action } from '@ngrx/store';
export enum ECompanyActions {
    GetAllCompanies = '[Company] Get All Companies',
    GetAllCompaniesSuccess = '[Company] Get All Companies Success',
    GetAllCompaniesErrorMessage = '[] Set Error Msg',
    CreateCompany = '[Company] Create Company',
    CreateCompanySuccess = '[Company] Create Success Msg',
    CreateCompanyError = '[Comapny] Create Error Msg',
    SetCompanySucessMessage = '[Company] Set Success Message',
    SetCompanyErrorMessage = '[Company] Set Error Message',
    EditCompany = '[Company] Edit Company',
    EditCompanySuccess = '[Comapany] Set Edit Company Success Msg',
    EditCompanyError = '[Company] Set Edit Company Error Msg',
    ConvertToActive = '[Company] Convert To Active',
    ConvertToActiveSuccess = '[Company] Convert To Active Success',
    ConvertToActiveError = '[Company] Convert To Active Error',
    RenewLicenseDate = '[Company] Renew Lincense Date ',
    RenewLicenseDateSuccess = '[Comapny] Set Renew Lincense Date Success Msg',
    RenewLicenseDateError = '[Comapany] Set Renew Lincense Date Error Msg',
    GiveExtensionDate = '[Company] Give Extension Date',
    GiveExtensionDateSuccess = '[Company] Give Extension Date Success msg',
    GiveExtensionDateError = '[Company] Give Extension Date Error Msg',
    GetCompanyById = '[Company] Get Company By Id',
    GetCompanyByIdSuccess = '[Company] Get Company By Id Success',
    GetCompanyByIdError = '[Company] Get Company By Id Error',
    InactivateCmpy = '[Company] InActivate Company',
    GetInactivateCmpySuccess = '[Company] Get Inactivate Company Success',
    GetInactivateCmpyError = '[Company] Get Inactivate Company Error',
    ActivateCmpy = '[Company] Activate Company',
    GetActivateCmpySuccess = '[Company] Get Activate Company Success',
    GetActivateCmpyError = '[Company] Get Activate Company Error',
    GetCompanyLicense = '[Company] Get Company License',
    GetCompanyLicenseSuccess = '[Company] Get Company License Success',
    GetCompanyLicenseError = '[Company] Get Company License Error',
    GetUsersCount = '[Company] Get Users Count',
    GetUsersCountSuccess = '[Company] Get Users Count Success',
    GetUsersCountError = '[Company] Get Users Count Error',
    GetAllUsers = '[Company] Get All Users',
    GetAllUsersSuccess = '[Company] Get All Users Success',
    GetAllUsersError = '[Company] Get All Users Error',
    BulkInactivate = '[Company] Bulk Inactivate',
    BulkInactivateSuccess = '[Company] Bulk Inactivate Success',
    BulkInactivateError = '[Company] Bulk Inactivate Error',
    BulkActivate = '[Company] Bulk Activate',
    BulkActivateSuccess = '[Company] Bulk Activate Success',
    BulkActivateError = '[Company] Bulk Activate Error',
    BulkDelete = '[Company] Bulk Delete',
    BulkDeleteSuccess = '[Company] Bulk Delete Success',
    BulkDeleteError = '[Company] Bulk Delete Error'

    // GetCompanyDetails = '[Company] Get Company Details',
    // GetCompanyDetailsSuccess = '[Company] Get Company Details Success',
}

export class CreateCompany implements Action {
    public readonly type = ECompanyActions.CreateCompany;
    constructor(public payload: any) {
        // console.log(payload)
     }
}

export class CreateCompanySuccess implements Action {
    public readonly type = ECompanyActions.CreateCompanySuccess;
    constructor(public payload: any, public store: any) {
    }
}

export class CreateCompanyError implements Action {
    public readonly type = ECompanyActions.CreateCompanyError;
    constructor(public payload: any, public store: any) {
        // console.log(payload)
    }
}

export class GetAllCompanies implements Action {
    public readonly type = ECompanyActions.GetAllCompanies;
    constructor(public payload: any) { }
}

export class GetAllCompaniesSuccess implements Action {
    public readonly type = ECompanyActions.GetAllCompaniesSuccess;
    constructor(public payload: any) { 
    }
}

export class GetAllCompaniesErrorMessage implements Action {
    public readonly type = ECompanyActions.GetAllCompaniesErrorMessage;
    constructor(public payload: any) { }
}

export class EditCompany implements Action {
    public readonly type = ECompanyActions.EditCompany;
    constructor(public payload: any) { }
}

export class EditCompanySuccess implements Action {
    public readonly type = ECompanyActions.EditCompanySuccess;
    constructor(public payload: any) { 
    }
}

export class EditCompanyError implements Action {
    public readonly type = ECompanyActions.EditCompanyError;
    constructor(public payload: any) { }
}


export class ConvertToActive implements Action {
  readonly type = ECompanyActions.ConvertToActive;
  constructor(public payload: any) {}
}
export class ConvertToActiveSuccess implements Action {
  readonly type = ECompanyActions.ConvertToActiveSuccess;
  constructor(public payload: any) {}
}
export class ConvertToActiveError implements Action {
  readonly type = ECompanyActions.ConvertToActiveError;
  constructor(public payload: any) {}
}
export class RenewLicenseDate implements Action {
    public readonly type = ECompanyActions.RenewLicenseDate;
    constructor(public payload: any) { }
}

export class RenewLicenseDateSuccess implements Action {
    public readonly type = ECompanyActions.RenewLicenseDateSuccess;
    constructor(public payload: any) { 
    }
}

export class RenewLicenseDateError implements Action {
    public readonly type = ECompanyActions.RenewLicenseDateError;
    constructor(public payload: any) { }
}
export class GiveExtensionDate implements Action {
    public readonly type = ECompanyActions.GiveExtensionDate;
    constructor(public payload: any) { }
}
export class GiveExtensionDateSuccess implements Action {
    public readonly type = ECompanyActions.GiveExtensionDateSuccess;
    constructor(public payload: any) { }
}
export class GiveExtensionDateError implements Action {
    public readonly type = ECompanyActions.GiveExtensionDateError;
    constructor(public payload: any) { }
}
export class GetCompanyById implements Action {
    public readonly type = ECompanyActions.GetCompanyById;
    constructor(public payload: any) { }

}
export class GetCompanyByIdSuccess implements Action {
    public readonly type = ECompanyActions.GetCompanyByIdSuccess;
    constructor(public payload: any) { }

}
export class GetCompanyByIdError implements Action {
    public readonly type = ECompanyActions.GetCompanyByIdError;
    constructor(public payload: any) { }

}
export class InactivateCmpy implements Action {
    public readonly type = ECompanyActions.InactivateCmpy;
    constructor(public payload: any) { }

}
export class GetInactivateCmpySuccess implements Action {
    public readonly type = ECompanyActions.GetInactivateCmpySuccess;
    constructor(public payload: any) { }

}
export class GetInactivateCmpyError implements Action {
    public readonly type = ECompanyActions.GetInactivateCmpyError;
    constructor(public payload: any) { }

}
export class ActivateCmpy implements Action {
    public readonly type = ECompanyActions.ActivateCmpy;
    constructor(public payload: any) { }

}
export class GetActivateCmpySuccess implements Action {
    public readonly type = ECompanyActions.GetActivateCmpySuccess;
    constructor(public payload: any) { }

}
export class GetActivateCmpyError implements Action {
    public readonly type = ECompanyActions.GetActivateCmpyError;
    constructor(public payload: any) { }

}
export class GetCompanyLicense implements Action {
    public readonly type = ECompanyActions.GetCompanyLicense;
    constructor(public payload: any) { }

}
export class GetCompanyLicenseSuccess implements Action {
    public readonly type = ECompanyActions.GetCompanyLicenseSuccess;
    constructor(public payload: any) { }

}
export class GetCompanyLicenseError implements Action {
    public readonly type = ECompanyActions.GetCompanyLicenseError;
    constructor(public payload: any) { }

}
export class GetUsersCount implements Action {
    public readonly type = ECompanyActions.GetUsersCount;
    constructor(public payload: any) { }

}
export class GetUsersCountSuccess implements Action {
    public readonly type = ECompanyActions.GetUsersCountSuccess;
    constructor(public payload: any) { }
}
export class GetUsersCountError implements Action {
    public readonly type = ECompanyActions.GetUsersCountError;
    constructor(public payload: any) { }
}
export class GetAllUsers implements Action {
    public readonly type = ECompanyActions.GetAllUsers;
    constructor(public payload: any) { }

}
export class GetAllUsersSuccess implements Action {
    public readonly type = ECompanyActions.GetAllUsersSuccess;
    constructor(public payload: any) { }
}
export class GetAllUsersError implements Action {
    public readonly type = ECompanyActions.GetAllUsersError;
    constructor(public payload: any) { }
}

export class BulkInactivate implements Action {
    public readonly type = ECompanyActions.BulkInactivate;
    constructor(public payload: any) { }
}
export class BulkInactivateSuccess implements Action {
    public readonly type = ECompanyActions.BulkInactivateSuccess;
    constructor(public payload: any) { }
}
export class BulkInactivateError implements Action {
    public readonly type = ECompanyActions.BulkInactivateError;
    constructor(public payload: any) { }
}
export class BulkActivate implements Action {
    public readonly type = ECompanyActions.BulkActivate;
    constructor(public payload: any) { }
}
export class BulkActivateSuccess implements Action {
    public readonly type = ECompanyActions.BulkActivateSuccess;
    constructor(public payload: any) { }
}
export class BulkActivateError implements Action {
    public readonly type = ECompanyActions.BulkActivateError;
    constructor(public payload: any) { }
}
export class BulkDelete implements Action {
    public readonly type = ECompanyActions.BulkDelete;
    constructor(public payload: any) { }
}
export class BulkDeleteSuccess implements Action {
    public readonly type = ECompanyActions.BulkDeleteSuccess;
    constructor(public payload: any) { }
}
export class BulkDeleteError implements Action {
    public readonly type = ECompanyActions.BulkDeleteError;
    constructor(public payload: any) { }
}


export type CompanyActions = CreateCompany | GetAllCompanies | GetAllCompaniesSuccess | GetAllCompaniesErrorMessage |
                            CreateCompanySuccess | CreateCompanyError | EditCompany | EditCompanySuccess | EditCompanyError |
                            RenewLicenseDate | RenewLicenseDateSuccess | RenewLicenseDateError|GiveExtensionDate|
                            GiveExtensionDateSuccess| GiveExtensionDateError| GetCompanyById| GetCompanyByIdSuccess|
                            GetCompanyByIdError|InactivateCmpy|GetInactivateCmpySuccess|GetInactivateCmpyError|
                            GetCompanyLicense|GetCompanyLicenseSuccess|GetCompanyLicenseError|ActivateCmpy|
                            GetActivateCmpySuccess|GetActivateCmpyError|GetUsersCount|GetUsersCountSuccess|GetUsersCountError|
                            GetAllUsers|GetAllUsersSuccess|GetAllUsersError|ConvertToActive|ConvertToActiveSuccess|ConvertToActiveError|BulkInactivate|BulkInactivateSuccess|BulkInactivateError|BulkActivate|BulkActivateSuccess|BulkActivateError|BulkDelete|BulkDeleteSuccess|BulkDeleteError;



